import { useNavigate } from "react-router-dom";
import useInView from "../lib/useInView";
import investIMG from "../images/hero-img-2.jpg";
import couple from '../images/about-img.png';
import sky from '../images/feat-cause.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHandHoldingHeart,
    faGlobe,
    faHandsHelping
} from "@fortawesome/free-solid-svg-icons";
import homeBg from "../images/about_img.png";
import { Helmet } from "react-helmet";
import mamitoIMG from "../images/mamito.jpeg";
import girlieIMG from "../images/girlie.jpeg";
import broIMG from "../images/bro.jpeg";
import Carousel from "../components/Carousel";

const Charity = () => {
    const navigate = useNavigate();

    const [boxImageRef, boxImageInView] = useInView({ threshold: 0.5 });
    const [box4Ref, box4InView] = useInView({ threshold: 0.7 });
    const [box6Ref, box6InView] = useInView({ threshold: 0.7 });
    const [boxVidRef, boxVidInView] = useInView({ threshold: 0.5 });
    const [boxSavingRef, boxSavingInView] = useInView({ threshold: 0.5 });
    const [heroRef, heroInView] = useInView({ threshold: 0.5 });
    const [box1Ref, box1InView] = useInView({ threshold: 0.7 });
    const [box7Ref, box7InView] = useInView({ threshold: 0.7 });
    const [box8Ref, box8InView] = useInView({ threshold: 0.7 });
    const [box9Ref, box9InView] = useInView({ threshold: 0.7 });

    return (
        <>
            <Helmet>
                <title>Our Charity Work – Mega Assets Foundation</title>
            </Helmet>

            <div id="hero-section">
                <div className="hero-section">
                    <div className="hero-text-container">
                        <h2 className="hero-description">
                            <span className="circle-text">Mega Assets Foundation</span>
                        </h2>
                        <h1 className="hero-title">
                            Empowering Communities. Changing Lives.
                        </h1>
                        <div
                            ref={boxSavingRef}
                            className={`sub-container animate__animated ${boxSavingInView ? "animate__flipInX" : ""}`}
                        >
                            <div className="sub-box">Education</div>
                            <div className="sub-box">Relief</div>
                            <div className="sub-box">Empowerment</div>
                        </div>
                    </div>

                    <div className="hero-image-container">
                        <img
                            src={sky}
                            alt="Charity Hero"
                            ref={box1Ref}
                            className={`hero-image animate__animated ${box1InView ? "custom-animation" : ""}`}
                        />
                    </div>
                </div>
            </div>

            <div className="two-box-cover">
                <div className="big-box">
                    <h2 className="text-heading">
                        Our Mission
                    </h2>
                    <p className="box-text">
                        At Mega Assets Foundation, we believe that everyone deserves a chance at a better future. Our mission is to uplift underprivileged communities through education, healthcare, economic empowerment, and emergency relief.
                    </p>
                    <p className="box-text">
                        From rural villages to urban slums, we work hand-in-hand with local partners to identify needs and deliver sustainable impact. Whether it's rebuilding after disaster, sending children to school, or supporting families in crisis—our goal is lasting change.
                    </p>
                    <p className="box-text">
                        With over $100 million raised and deployed globally, we’re committed to transparency, compassion, and real-world results.
                    </p>
                </div>

                <div className="small-box">
                    <img
                        ref={heroRef}
                        src={investIMG}
                        alt="Impact Work"
                        className={`box-image animate__animated ${heroInView ? "animate__zoomIn" : ""}`}
                    />
                </div>
            </div>

            <div className="video-section">
                <div
                    ref={boxVidRef}
                    className={`hero-image-container animate__animated ${boxVidInView ? "animate__zoomIn" : ""}`}
                >
                    <img src={couple} alt="Community Impact" className="box-image" />
                </div>

                <div className="hero-text-container">
                    <h2 className="box-title">Transparent Giving, Real Impact</h2>
                    <h2 className="hero-title">
                        Every Donation You Make Helps a Family, a Child, and a Community Thrive.
                    </h2>

                    <button
                        onClick={() => navigate("/node")}
                        className="delete-button"
                    >
                        Donate Now
                    </button>
                </div>
            </div>

            <div className="heading-cover-bg">
                <div className="last-section">
                    <div className="box">
                        <h2 className="black-title">
                            Building Hope Through Collaboration
                        </h2>
                        <div className="black-title">
                            We work with schools, hospitals, and grassroots organizations to ensure resources reach the right hands. From clean water and food access to trauma recovery and resettlement, our teams are on the front lines.
                        </div>
                        <div className="box-text">
                            <h3 className="black-title">Disaster Relief & Recovery</h3>
                            <p className="black-title">
                                Whether it’s a natural disaster or conflict, we provide emergency support and long-term recovery solutions to communities in need.
                            </p>
                        </div>
                    </div>

                    <div className="box">
                        <img
                            src={homeBg}
                            alt="Relief Work"
                            ref={boxImageRef}
                            className={`box-image animate__animated ${boxImageInView ? "animate__zoomIn" : ""}`}
                        />
                    </div>

                    <div className="box">
                        <div
                            ref={box6Ref}
                            className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faGlobe} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title black-title">Global Reach</h3>
                                <div className="black-title">
                                    With operations across continents, we bring relief, hope, and opportunity to some of the world's most underserved areas.
                                </div>
                            </div>
                        </div>

                        <div
                            ref={box4Ref}
                            className={`icon-title-text-container animate__animated ${box4InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faHandsHelping} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title black-title">Partnerships for Progress</h3>
                                <div className="black-title">
                                    Collaborating with governments, NGOs, and local leaders to make real change happen—together.
                                </div>
                            </div>
                        </div>

                        <div
                            ref={box4Ref}
                            className={`icon-title-text-container animate__animated ${box4InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faHandHoldingHeart} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title black-title">Sustainable Solutions</h3>
                                <div className="black-title">
                                    Beyond charity, we aim to empower—through education, training, and tools that last.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Carousel />

            <div className="main-box-cover">
                <h2 className="text-heading centered">
                    Changing Lives – <span>One Project at a Time.</span>
                </h2>
                <div className="box-text centered">
                    We don’t just donate—we engage. Our foundation supports a growing portfolio of social impact programs across education, resettlement, women’s rights, and poverty alleviation. Join us in shaping a more compassionate, equitable future for all.
                </div>
            </div>

            <div className="last-section">
                <div className="box">
                    <div
                        ref={box9Ref}
                        className={`icon-title-text-container animate__animated ${box9InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={girlieIMG}
                            className="boxed-icon"
                            alt="Global Outreach"
                        />
                        <div className="title-text">
                            <h2 className="box-title">Global Outreach</h2>
                            <div className="box-text">
                                Supporting humanitarian efforts worldwide, delivering food, education, and aid to conflict zones and disaster areas.
                            </div>
                        </div>
                    </div>
                    <h2 className="text-heading centered">
                        Be a part of a movement that saves lives and restores dignity.
                    </h2>
                    <button
                        className="cta-button"
                        onClick={() => navigate("/node")}
                    >
                        Support Our Mission
                    </button>
                </div>

                <div className="box">
                    <div
                        ref={box7Ref}
                        className={`icon-title-text-container animate__animated ${box7InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={mamitoIMG}
                            className="boxed-icon"
                            alt="Empowerment"
                        />
                        <div className="title-text">
                            <h2 className="box-title">Women & Youth Empowerment</h2>
                            <div className="box-text">
                                Providing vocational training, small business support, and access to financial literacy so people can lift themselves out of poverty.
                            </div>
                        </div>
                    </div>

                    <div
                        ref={box8Ref}
                        className={`icon-title-text-container animate__animated ${box8InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={broIMG}
                            className="boxed-icon"
                            alt="Education"
                        />
                        <div className="title-text">
                            <h2 className="box-title">Education for All</h2>
                            <div className="box-text">
                                From classrooms to refugee camps, we invest in children’s futures by funding scholarships, supplies, and safe learning environments.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Charity;
